'use client'

import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { MultiSelectList } from '@repo/ui/MultiSelectList'
import { useLookupsStore } from '@repo/store/useLookupsStore'

export const GroupMultiSelect = ({
  testData = null,
  value = null,
  onChange = (val) => {
    console.log(val)
  },
  sx
}) => {
  const { fetchAllGroups, allGroups } = useLookupsStore()
  const [options, setOptions] = useState(testData || allGroups || [])

  useEffect(() => {
    if (testData) return
    setOptions(allGroups || [])
  }, [testData, allGroups])

  useEffect(() => {
    if (testData || allGroups?.length) return
    fetchAllGroups()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testData, allGroups])

  return (
    <div data-testid="GroupMultiSelect" style={{ width: sx?.width || '100%', maxWidth: sx?.maxWidth || '100%', ...sx }}>
      <MultiSelectList
        label="Groups"
        onChange={onChange}
        labelKey="description"
        valueKey="name"
        items={options}
        value={value}
        idLabelKey="name"
        name="groups"
        sx={sx}
      />
    </div>
  )
}

GroupMultiSelect.propTypes = {
  testData: PropTypes.array,
  value: PropTypes.array,
  onChange: PropTypes.func,
  sx: PropTypes.object,
  size: PropTypes.string,
  required: PropTypes.bool
}
